// assets
import { IconTypography, IconUserCircle, IconPalette, IconShadow, IconWindmill, IconBuildingBank, IconWallet,IconFileCertificate, IconUserPlus, IconLicense } from '@tabler/icons';

// constant
const icons = {
  IconTypography,
  IconPalette,
  IconShadow,
  IconWindmill,
  IconBuildingBank,
  IconWallet,
  IconFileCertificate,
  IconUserPlus,
  IconUserCircle,
  IconLicense
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const utilities = {
  id: 'utilities',
  title: 'My Account',
  type: 'group',
  children: [
    {
      id: 'util-profile',
      title: 'Profile',
      type: 'item',
      url: '/dashboard/profile',
      icon: icons.IconUserCircle,
      breadcrumbs: false
    },
    {
      id: 'util-shadow',
      title: 'Request Services',
      type: 'item',
      url: '/dashboard/servicerequest',
      icon: icons.IconUserPlus,
      breadcrumbs: false
    },
    // {
    //   id: 'util-typography',
    //   title: 'Agreement',
    //   type: 'item',
    //   url: '/dashboard/agreement',
    //   icon: icons.IconLicense,
    //   breadcrumbs: false
    // },
    // {
    //   id: 'util-color',
    //   title: 'Savings A/C',
    //   type: 'item',
    //   url: '/dashboard/default',
    //   icon: icons.IconBuildingBank,
    //   breadcrumbs: false
    // },

    {
      id: 'util-service',
      title: 'Request Status',
      type: 'item',
      url: '/dashboard/requeststatus',
      icon: icons.IconFileCertificate,
      breadcrumbs: false
    },
    // {
    //   id: 'icons',
    //   title: 'Icons',
    //   type: 'collapse',
    //   icon: icons.IconWindmill,
    //   children: [
    //     {
    //       id: 'tabler-icons',
    //       title: 'Tabler Icons',
    //       type: 'item',
    //       url: '/dashboard/default',
    //       breadcrumbs: false
    //     },
    //     {
    //       id: 'material-icons',
    //       title: 'Material Icons',
    //       type: 'item',
    //       external: true,
    //       target: '_blank',
    //       url: '/dashboard/default',
    //       breadcrumbs: false
    //     }
    //   ]
    // }
  ]
};

export default utilities;
